import { useAuthStore } from '@/store/auth/auth'
import { useRouter } from 'vue-router'
import { useResetStore } from '@/helpers/resetStore'

export const useLogout = () => {
  const authStore = useAuthStore()
  const router = useRouter()
  const resetStore = useResetStore()

  const resetStores = () => resetStore.all()

  const logout = async () => {
    try {
      await authStore.logout()
      await router.push('/login')
      resetStores()
    } catch (error) {
      console.error(error)
    }
  }

  const adminLogout = async () => {
    try {
      await authStore.adminLogout()
      await router.push('/admin/login')
      resetStores()
    } catch (error) {
      console.error(error)
    }
  }

  return { logout, adminLogout }
}
